export enum AsyncSwapStatus {
    Awaiting = "awaiting",
    Processing = "processing",
    Provisioning = "provisioning",
    Converting = "converting",
    Settling = "settling",
    Completed = "completed",
    Reversing = "reversing",
    Reversed = "reversed"
}

export interface AsyncSwapStatusResponse {
    redemptionId: string;
    status: AsyncSwapStatus;
    settledAt?: string;
    settlementTransactionHash?: string;
    error?: string;
    network: string;
}

export interface AsyncSwapStatusParams {
    redemptionId: string;
    routeType: string;
    // GLAM polls require the vault's state PDA. Read from the redeem quote's routeStep.state
    // (GlamRouteParams) at the call site and forward here.
    state?: string;
}
